var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TextImage',{attrs:{"headline":_vm.$t('sichtbeton.headline'),"subline":_vm.$t('sichtbeton.subline'),"text":_vm.$t('sichtbeton.text') + '<br><a href=\'https://sichtbeton-forum.de\'>' + _vm.$t('global.read_more') + '</a>',"image":"/assets/images/bkamt.jpg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }